export default __webpack_public_path__ + "static/media/NDL_37.7bf49189.png";